import ApiRequest from "../util/ApiRequest";
import GlobalData from "../util/GlobalData";

export default class ComplaintForm {
    create = async (body) => {
        return await ApiRequest.set(`/v1/complaint_forms`, "POST", body);
    }
}
